import { createSlice } from "@reduxjs/toolkit";
import { OrganizationModalFieldsJSON } from "../../pages/Org/Organization/Json/OrganizationFieldsJson";
import { organizationTabs } from "../../pages/Org/Organization/Json/OrganizationJson";
import { ORG_FROM_DATE, ORG_TO_DATE } from "../../Utils/FilterDateKeys";
import dateFormat from "dateformat";
import { getOrgId } from "../../Utils/CommonUtils";

const enterpriseid = localStorage.getItem("enterpriseid");

const initialState = {
  organizationData: [],
  organizationFieldsJson: OrganizationModalFieldsJSON,
  selectedOrganization: {
    tabs: organizationTabs,
    activeTab: "details",
    detailsData: {},
    orgMappingData: [],
    orgtoOrgMappingData: "",
    selectedTreeObject: {},
    orgCode: "",
    hierCode: "",
    menus: {},
    parentId: "",
    selectedHierarchy: null,
  },
  sorting: {
    column: "created_date",
    order: "DESC",
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // parent_id: localStorage.getItem("selectedUser")
      // ? JSON.parse(localStorage.getItem("selectedUser")).organizationid
      // : "",

      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [ORG_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [ORG_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizationData: (state, action) => {
      state.organizationData = action.payload;
    },
    setOrganizationFieldsJson: (state, action) => {
      state.organizationFieldsJson = action.payload;
    },
    changeActiveTab: (state, action) => {
      state.selectedOrganization.activeTab = action.payload;
    },
    setOrgMappingData(state, action) {
      state.selectedOrganization.orgMappingData = action.payload;
    },
    setOrganizationIdData: (state, action) => {
      state.selectedOrganization.detailsData = action.payload;
    },
    setTreeData: (state, action) => {
      state.selectedOrganization.menus = action.payload;
    },
    setSelectedHierarchy: (state, action) => {
      state.selectedOrganization.selectedHierarchy = action.payload;
    },
    setOrgCode: (state, action) => {
      state.selectedOrganization.orgCode = action.payload;
    },
    setHierarchyCode: (state, action) => {
      state.selectedOrganization.hierCode = action.payload;
    },
    setOrgToOrgMappingData: (state, action) => {
      state.selectedOrganization.orgtoOrgMappingData = action.payload;
    },
    setSelectedTreeObject: (state, action) => {
      state.selectedOrganization.orgtoOrgMappingData = action.payload;
    },
    setParentId: (state, action) => {
      state.selectedOrganization.parentId = action.payload;
    },
    setOrganizationFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    setOrganizationFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [AG_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [AG_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[ORG_FROM_DATE];
          delete state.filter.form[ORG_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setOrganizationFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setOrganizationSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
  },
});

export const {
  setOrganizationData,
  setOrganizationFieldsJson,
  changeActiveTab,
  setOrgMappingData,
  setOrganizationIdData,
  setSelectedHierarchy,
  setTreeData,
  setOrgCode,
  setHierarchyCode,
  setOrgToOrgMappingData,
  setSelectedTreeObject,
  setParentId,
  setOrganizationFilterApi,
  setOrganizationFilterForm,
  setOrganizationFilterFormCopy,
  setOrganizationSorting,
} = organizationSlice.actions;

export default organizationSlice.reducer;
